import { render, staticRenderFns } from "./BackgroundBlurIcon.vue?vue&type=template&id=0bec2b71&"
import script from "./BackgroundBlurIcon.vue?vue&type=script&lang=js&"
export * from "./BackgroundBlurIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports